<template>
  <div class="sticky-top fixed-top theme">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <!-- Container wrapper -->
      <div class="container">
        <!-- Navbar brand -->
        <div class="navbar-nav me-auto mb-lg-0">
          <div class="nav-item" @click="home()">
            <a v-if="logo == ''" class="nav-link pointer" href="#">{{
              this.$store.getters.webname
            }}</a>
            <img v-else :src="logo" height="40" class="pointer my-1" />
          </div>
        </div>

        <ul class="navbar-toggler border-0" style="list-style-type: none">
          <li>
            <!-- <button
              type="button"
              class="btn btn-light btn-sm p-1 mx-1"
              data-bs-toggle="modal"
              data-bs-target="#modalRegisterID"
              @click="clickback"
            >
              <i class="bi bi-person-plus-fill"></i>
              สมัครสมาชิก
            </button> -->
            <!-- <button
              type="button"
              class="btn btn-warning btn-sm p-1 mx-1"
              data-bs-toggle="modal"
              data-bs-target="#modalLoginID"
            >
              <i class="bi bi-box-arrow-in-right"></i>
              เข้าสู่ระบบ
            </button> -->
          </li>
          <!-- <li>
            <button
              type="button"
              class="btn btn-warning btn-sm mb-1"
              data-bs-toggle="modal"
              data-bs-target="#modalLoginID"
            >
              <i class="bi bi-box-arrow-in-right"></i>
              เข้าสู่ระบบ
            </button>
          </li> -->
        </ul>
        <!-- Toggle button -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
        >
          <i class="bi bi-list"></i>
        </button>

        <!-- Collapsible wrapper -->
        <div class="navbar-collapse collapse" id="navbar">
          <!-- Left links -->
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <!-- <li class="nav-item">
              <a class="nav-link" href="#">{{ this.$store.getters.webname }}</a>
            </li> -->
          </ul>
          <!-- Left links -->
          <div class="d-flex align-items-center">
            <router-link
              to="/"
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
            >
              หน้าบ้าน
            </router-link>

            <!-- <button
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
              disabled
            >
              บทความ
            </button> -->

            <a
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
              @click="this.newtab(line_url)"
            >
              ติดต่อเรา
            </a>

            <button
              type="button"
              class="btn btn-light mx-1"
              @click="navigate('register')"
            >
              <i class="bi bi-person-plus-fill"></i>
              สมัครสมาชิก
            </button>

            <button
              type="button"
              class="button-login mx-1"
              @click="navigate('login')"
            >
              <i class="bi bi-box-arrow-in-right"></i>
              เข้าสู่ระบบ
            </button>
          </div>
        </div>
        <!-- Collapsible wrapper -->
      </div>
      <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
  </div>

  <!-- Collapsible offcanvas -->
  <div
    class="offcanvas offcanvas-end bg-dark"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
  >
    <!-- Left links -->
    <div class="offcanvas-header">
      <li class="nav-item">
        <a v-if="logo2 == ''" class="nav-link" href="#">{{
          this.$store.getters.webname
        }}</a>
        <img v-else :src="logo2" height="80" class="my-1" />
      </li>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <!-- Left links -->
    <div class="offcanvas-body">
      <div class="d-flex align-items-center">
        <ul data-bs-dismiss="offcanvas">
          <li>
            <button
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
              @click="home()"
            >
              <i class="bi bi-house-fill mx-3" style="font-size: 2rem"></i>
              หน้าบ้าน
            </button>
          </li>
          <!-- <li>
            <button
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
              disabled
            >
              <i class="bi bi-book mx-3" style="font-size: 2rem"></i>
              บทความ
            </button>
          </li> -->
          <li>
            <a
              type="button"
              class="btn btn-link px-2 text-decoration-none link-light"
              @click="this.newtab(line_url)"
            >
              <i
                class="bi bi-telephone-forward-fill mx-3"
                style="font-size: 2rem"
              ></i>
              ติดต่อเรา
            </a>
          </li>
          <li class="mb-3 mt-2">
            <button
              type="button"
              id="register"
              class="btn btn-link px-2 text-decoration-none link-light"
              @click="navigate('register')"
            >
              <i
                class="bi bi-person-plus-fill mx-3"
                style="font-size: 2rem"
              ></i>
              สมัครสมาชิก
            </button>
          </li>
          <li class="mb-3 mt-2">
            <button
              type="button"
              id="login"
              class="btn btn-link px-2 text-decoration-none link-light"
              @click="navigate('login')"
            >
              <i
                class="bi bi-box-arrow-in-right mx-3"
                style="font-size: 2rem"
              ></i>
              เข้าสู่ระบบ
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div class="offcanvas-footer">
        <ul class="text-decoration-none link-light mx-3 my-4">
          <strong>ติดต่อผ่านช่องทางออนไลน์</strong>
          <a
            @click="this.newtab(line_url)"
            class="text-light pointer my-2"
            data-bs-dismiss="offcanvas"
          >
            @{{ this.$store.getters.webname }}
          </a>
          <div
            v-for="item in contact.right"
            :key="item"
            class="my-3"
            data-bs-dismiss="offcanvas"
          >
            <img
              fluid
              :src="item.img"
              width="50"
              class="pointer"
              @click="this.newtab(item.url)"
            />
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'AppHeader',
  data() {
    return {
      ipinfo: {},
      logo: '',
      logo2: '',
      page: '',
      line_url: sessionStorage.getItem('line_url'),
      contact: [],
    }
  },
  setup() {
    return {}
  },
  components: {},
  async mounted() {
    this.getvanip()
    await this.callwhitelist()
    await this.setlayout_loginpage()
    let temp = window.location.href
    temp = temp.split('/')
    this.page = temp[3]
    console.log('page', this.page)
  },
  methods: {
    home() {
      this.$router.push('/')
    },
    navigate(page) {
      this.$router.push('/' + page)
    },
    newtab(URL) {
      window.open(URL, '_blank')
    },
    async getvanip() {
      try {
        await axios.get('https://ipinfo.io/json').then((response) => {
          this.ipinfo = response.data
          console.log('ipinfo')
        })
      } catch (e) {
        console.log(e)
      }
    },
    changeBackgroundImage(img) {
      const head = document.getElementsByTagName('head')[0]
      const style = document.createElement('style')
      style.innerHTML = `.body {
      background: url(${img}) no-repeat center center fixed;
    }`
      head.appendChild(style)
    },
    async callwhitelist() {
      this.$store.commit('setapiname', 11013)
      this.$store.commit('setAPI')
      await axios
        .post(this.$store.getters.API, {
          //****************IF Deploy Remark**************** */
          // domain_name: 'https://www.goodluck711.com',
          //************************************************ */
        })
        .then((resp) => {
          console.log('callwhitelist')
          sessionStorage.setItem('device', resp.data.result.device)
          sessionStorage.setItem('aid', resp.data.result.agent_id)
          this.$store.commit('setagentid', sessionStorage.getItem('aid'))
        })
        .catch((error) => {
          console.log(error)
          Swal.fire({
            title: 'ผิดพลาด!!!',
            text: 'ระบบผิดพลาดกรุณา เข้าใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'ตกลง',
          })
        })
    },
    async setlayout_loginpage() {
      this.$store.commit('setapiname', 12003)
      this.$store.commit('setAPI')
      await axios
        .post(this.$store.getters.API, {
          agent_id: this.$store.getters.agent_id,
        })
        .then((resp) => {
          console.log('setlayout_loginpage')
          if (resp.data.status == 200 || resp.data.status == 201) {
            this.$store.commit('setimg_bg', resp.data.result.background)
            this.img = this.$store.getters.img_bg
            if ((this.img !== null) & (this.img !== '')) {
              this.changeBackgroundImage(this.img)
            }
            // this.color = 'theme_purple'
            this.color = 'theme_' + resp.data.result.color
            const theme = document.querySelectorAll('.theme')
            theme.forEach((item) => {
              item.classList.remove('theme')
              item.classList.add(this.color)
            })
            this.logo = resp.data.result.logo1
            this.logo2 = resp.data.result.logo2
          }
        })
        .catch((error) => {
          console.log('setlayout_loginpage', error)
        })
    },
  },
}
</script>

<style scoped>
@import '@/styles/theme_color.css';
</style>
